import { searchResultsContentId } from '../actions/search';

const NAMESPACE = 'search';

export const selectSearchResults = (state) => state?.[NAMESPACE]?.[searchResultsContentId];
